import { render } from "./whatsapp-profile.vue?vue&type=template&id=3d3ffa7b"
import script from "./whatsapp-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./whatsapp-profile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/whatsapp-profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d3ffa7b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d3ffa7b', __exports__)) {
    console.log('reload')
    api.reload('3d3ffa7b', __exports__)
  }
  
  module.hot.accept("./whatsapp-profile.vue?vue&type=template&id=3d3ffa7b", () => {
    console.log('re-render')
    api.rerender('3d3ffa7b', render)
  })

}


export default __exports__